import { Dropdown } from 'bootstrap';

const desktopPointer = window.matchMedia('(min-width: 992px) and (hover: hover) and (pointer: fine)');

function dropdownInstance(toggle) {
  return Dropdown.getOrCreateInstance(toggle, {
    autoClose: true,
    display: 'static'
  });
}

function closeOtherHeaderMenus(currentItem) {
  document.querySelectorAll('.app-header-hover-dropdown').forEach((item) => {
    if (item === currentItem) return;

    const toggle = item.querySelector(':scope > [data-bs-toggle="dropdown"]');
    if (toggle) dropdownInstance(toggle).hide();
  });
}

function closeAllHeaderMenus() {
  document.querySelectorAll('.app-header [data-bs-toggle="dropdown"]').forEach((toggle) => {
    const instance = Dropdown.getInstance(toggle);
    if (instance) instance.hide();
  });
}

function initializeHeaderDropdowns() {
  const header = document.querySelector('.app-header');
  if (header && header.dataset.dropdownBoundaryReady !== 'true') {
    let headerCloseTimer = null;
    header.addEventListener('mouseenter', () => {
      if (headerCloseTimer) window.clearTimeout(headerCloseTimer);
      headerCloseTimer = null;
    });
    header.addEventListener('mouseleave', () => {
      if (!desktopPointer.matches) return;
      if (headerCloseTimer) window.clearTimeout(headerCloseTimer);
      headerCloseTimer = window.setTimeout(() => {
        if (!header.matches(':hover')) closeAllHeaderMenus();
      }, 120);
    });
    header.dataset.dropdownBoundaryReady = 'true';
  }

  document.querySelectorAll('.app-header-hover-dropdown').forEach((item) => {
    if (item.dataset.headerDropdownReady === 'true') return;

    const toggle = item.querySelector(':scope > [data-bs-toggle="dropdown"]');
    const menu = item.querySelector(':scope > .dropdown-menu');
    if (!toggle || !menu) return;

    let closeTimer = null;

    const cancelClose = () => {
      if (closeTimer) window.clearTimeout(closeTimer);
      closeTimer = null;
    };

    const openMenu = () => {
      if (!desktopPointer.matches) return;
      cancelClose();
      closeOtherHeaderMenus(item);
      dropdownInstance(toggle).show();
    };

    const closeMenu = () => {
      if (!desktopPointer.matches) return;
      cancelClose();
      closeTimer = window.setTimeout(() => {
        if (!item.matches(':hover')) dropdownInstance(toggle).hide();
      }, 180);
    };

    item.addEventListener('mouseenter', openMenu);
    item.addEventListener('mouseleave', closeMenu);
    item.addEventListener('focusin', openMenu);
    toggle.addEventListener('click', (event) => {
      if (!desktopPointer.matches) return;

      event.preventDefault();
      event.stopPropagation();
      openMenu();
    });
    item.addEventListener('focusout', (event) => {
      if (!item.contains(event.relatedTarget)) closeMenu();
    });
    menu.addEventListener('mouseenter', cancelClose);

    item.dataset.headerDropdownReady = 'true';
  });
}

document.addEventListener('turbolinks:load', initializeHeaderDropdowns);

document.addEventListener('turbolinks:before-cache', () => {
  closeAllHeaderMenus();
});
